$(function() {
	// @codekit-prepend '../js/admin/functions.js'
	// @codekit-prepend '../js/admin/pusher.js'
	// @codekit-prepend '../js/admin/notifications.js'
	// @codekit-prepend '../js/admin/file-uploader.js'
	// @codekit-prepend '../js/admin/files-uploader.js'
	// @codekit-prepend '../js/admin/dropdown.js'

	// @codekit-prepend '../js/admin/dashboard.js'
	// @codekit-prepend '../js/admin/settings.js'
	// @codekit-prepend '../js/admin/site-text.js'
	// @codekit-prepend '../js/admin/site-settings.js'
	// @codekit-prepend '../js/admin/admins.js'
	// @codekit-prepend '../js/admin/crons.js'
	// @codekit-prepend '../js/admin/email-templates.js'
	// @codekit-prepend '../js/admin/sent-emails.js'
	// @codekit-prepend '../js/admin/payments.js'
    // @codekit-prepend '../js/admin/accounts.js'
    
	// @codekit-prepend '../js/admin/years.js'
	// @codekit-prepend '../js/admin/coupons.js'
	// @codekit-prepend '../js/admin/owners.js'
	// @codekit-prepend '../js/admin/owner.js'
	// @codekit-prepend '../js/admin/seats.js'
	// @codekit-prepend '../js/admin/year-seats.js'
	// @codekit-prepend '../js/admin/year-seat.js'
	// @codekit-prepend '../js/admin/canned-messages.js'

});